export default __webpack_public_path__ + "static/media/5095.95328ff6.png";